import React, { useState, useEffect } from 'react'
import { string, array, number } from 'prop-types'
import styles from './EventTestimonialGrid.module.scss'
import Grid from '@/component/Primitive/Grid'
import EventTestimonial from './components/EventTestimonial'
import cx from 'classnames'
import Container from '@/component/Primitive/Container'
import Stack from '@/component/Primitive/Stack'

export const EventTestimonialGrid = ({ list, theme, rowLimit }) => {
  const [rows, setRows] = useState([])

  useEffect(() => {
    const splitArray = (l, size) => {
      const arrays = []
      while (l.length > 0) {
        arrays.push(l.splice(0, size))
      }
      return arrays
    }
    setRows(rowLimit ? splitArray(list, rowLimit) : list)
  }, [list, rowLimit])

  return (
    <div
      className={cx(
        styles.EventTestimonialGrid,
        theme === 'light' && styles.light,
        theme === 'dark' && styles.dark
      )}
    >
      <Container
        center
        size="wide"
        gutter
        className={styles.EventDetailsContainer}
      >
        <Stack gap="small">
          <Grid flex gutter="default">
            <div className={styles.GridInner}>
              {rows?.map((list, i) => (
                <div key={i} className={styles.Row}>
                  {list?.map((item, j) => (
                    <EventTestimonial
                      key={j}
                      theme={theme}
                      flex={1}
                      {...item}
                    />
                  ))}
                </div>
              ))}
            </div>
          </Grid>
        </Stack>
      </Container>
    </div>
  )
}

EventTestimonialGrid.propTypes = {
  list: array,
  theme: string,
  rowLimit: number
}
